import {AppComponent} from 'app/app.component';
import {MessageService} from 'primeng/api';
import {Router, ActivatedRoute, ParamMap} from '@angular/router';
import {ConfirmationService} from 'primeng/api';
import {ItemsService} from './items.service';
import { Directive } from "@angular/core";
import {AppBreadcrumbService} from '../../app.breadcrumb.service';


@Directive()
export abstract class ListComponent {


    items: any[] = [];

    selectedItems: any[] = [];
    
    globalFilter :any[] = ['name'];

    cols: any[];

    title: string = 'List of items';
    
    canAdd : boolean = true;
    
    canRemove : boolean= true;
    
    canActive : boolean = true;

    constructor(private confirmationService: ConfirmationService, private messageService: MessageService, private service: ItemsService,
        private app: AppComponent, private breadcrumbService: AppBreadcrumbService) {
    }

    abstract getPath(): string;

    abstract getCols(): any[];

    ngOnInit() {
        this.cols = this.getCols();
        this.breadcrumbService.setItems([
            { label: 'Administration' },
            { label: this.title, routerLink: ['/'+this.getPath()+"s"] }
        ]);
        
        this.service.getItems().then(data => {
            this.selectedItems = []
            this.items = data.sort((n1:any,n2:any) => {
               return n1.name == n2.name ? 0 : n1.name > n2.name ? 1 : -1;
            });
        },
        res => {
            this.messageService.add({severity: 'error', summary: 'Erreur', detail: res.statusText});
        });
        this.globalFilter = this.getCols().filter(item => item.filtered && item.type == 'text')
        .map(item => item.field);

    }
    stateChange(item:any){
        if(item.active){
            this.active([item]);
        }
        else{
            this.desactive([item]);
            }
    }
    get(item: any, field: string): string {
        let flds = field.split(".");
        let it = item;
        for (let key in flds) {
            it = flds[key] in it ? it[flds[key]] : '';
        }
        return it;
    }
    getServiceName() {
        this.service.getServiceName();
    }

    active(ids = null) {
        this.service.activeItems(ids == null ? this.selectedItems : ids).then(res => {
            this.messageService.add({severity: 'success', summary: 'Success', detail: 'Item(s) active with success'});
            if(ids == null)
                this.ngOnInit();
        }, res => {
            this.messageService.add({severity: 'error', summary: 'Operation Erreur', detail: res.statusText});
        });
    }

    desactive(ids = null) {
        this.service.desactiveItems(ids == null? this.selectedItems : ids).then(res => {
            this.messageService.add({severity: 'success', summary: 'Success', detail: 'Item(s) desactive with success'});
            if(ids == null)
                this.ngOnInit();
        }, res => {
            this.messageService.add({severity: 'error', summary: 'Operation Erreur', detail: res.statusText});
        });
    }

    delete() {
        this.confirmationService.confirm({
            message: 'Are you sure that you want to perform this action?',
            accept: () => {
                this.service.removeItems(this.selectedItems).then(res => {
                    this.messageService.add({severity: 'success', summary: 'Success', detail: 'Item(s) remove with success'});
                    this.ngOnInit();
                }, res => {
                    this.messageService.add({severity: 'error', summary: 'Operation Erreur', detail: res.statusText});
                });
            }
        });
    }

}


@Directive()
export abstract class ItemComponent {

    item: any = {};

    edit: boolean = false;

    constructor(private messageService: MessageService, private service: ItemsService,
        private app: AppComponent, private router: Router, private route: ActivatedRoute, private breadcrumbService: AppBreadcrumbService) {}

    ngOnInit() {
        this.route.paramMap.subscribe((params: ParamMap) => {
            const id = this.route.snapshot.paramMap.get('id');
            if (id) {
                this.service.getItem(id).then(item => {
                    this.item = item;
                    this.edit = true;
                    this.prepareEdit();
                },
                    res => {
                        this.messageService.add({severity: 'error', summary: 'Erreur', detail: res.statusText});
                        this.router.navigate(['/' + this.getPath() + 's']);
                    });
            }
            else {
                this.edit = false;
                this.prepareCreate();
            }
            
            this.breadcrumbService.setItems([
                { label: 'Administration' },
                { label: 'Items List', routerLink: ['/'+this.getPath()] },
                { label: this.edit ? 'Item/'+this.item.id :'New'}
            ]);
        });

    }
    abstract getPath(): string;

    getSuccessMessage() {
        return 'Item save with success';
    }
    prepareEdit() {

    }
    prepareCreate() {
        this.item = {};

    }
    addCheck() {
        return true;
    }
    prepareSave() {

    }
    save() {
        if (this.addCheck()) {
            this.prepareSave();
            this.service.create(this.item).then(res => {
                this.router.navigate(['/backendadmin/' + this.getPath()]).then(() => {
                    this.messageService.add({severity: 'success', summary: 'Success', detail: this.getSuccessMessage()});
                });
                
            }, res => {
                this.messageService.add({severity: 'error', summary: 'Save Erreur', detail: res.statusText});
            });
        }
    }

}
